<template>
  	<SubscriptionCode />
</template>

<script>

// @ is an alias to /src
import SubscriptionCode from "@/components//SubscriptionBaseSales/subscriptionCode/SubscribersList.vue";

export default {
  name: "SubscriptionCodeList",
  components: {
    SubscriptionCode,
  },
};
</script>
